import React from 'react';
import PropTypes from 'prop-types';
import { graphql, createFragmentContainer } from 'react-relay';
import get from 'lodash.get';

// components
import ItemImage from '../../../components/global/ItemImage';

// styles
import styles from './PdpRespSimilarItemCarousel.scss';

export function PdpRespSimilarItemCarousel({ index, item, onClick, isClient }) {
    const { title, pdpURL, isArt } = item;
    const creatorName = get(item, 'creators[0].creator.name');

    return (
        <div className={styles.itemContainer} onClick={() => onClick(index)}>
            <a href={pdpURL} className={styles.link}>
                <div className={styles.item}>
                    <div className={styles.overlay}>
                        <p className={styles.title}>
                            {isArt && creatorName && `${creatorName} - `}
                            {title}
                        </p>
                    </div>
                    <ItemImage
                        className={styles.image}
                        alt={title}
                        isClient={isClient}
                        item={item}
                        sizes="10vw"
                    />
                </div>
            </a>
        </div>
    );
}

PdpRespSimilarItemCarousel.propTypes = {
    index: PropTypes.number.isRequired,
    item: PropTypes.object.isRequired,
    onClick: PropTypes.func,

    //options
    isClient: PropTypes.bool.isRequired,
};

export default createFragmentContainer(PdpRespSimilarItemCarousel, {
    item: graphql`
        fragment PdpRespSimilarItemCarousel_item on Item {
            title
            pdpURL
            isArt
            creators {
                creator {
                    name
                }
            }
            ...ItemImage_item
        }
    `,
});
